import { render, staticRenderFns } from "./independent-program-list.vue?vue&type=template&id=1d84d364&scoped=true&"
import script from "./independent-program-list.ts?vue&type=script&lang=ts&"
export * from "./independent-program-list.ts?vue&type=script&lang=ts&"
import style0 from "./independent-program-list.scss?vue&type=style&index=0&id=1d84d364&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84d364",
  null
  
)

export default component.exports